// @ts-nocheck
import ChangeCustomerModalReducer, {
    GreifComponentsChangeCustomerModalActions,
} from "@store/Framework/Store/Greif/Components/ChangeCustomerModal/ChangeCustomerModalReducer";
import cookiePrivacyPolicyReducer, {
    GreifComponentsCookiePrivacyPolicyActions,
} from "@store/Framework/Store/Greif/Components/CookiePrivacyPolicy/CookiePrivacyPolicyReducer";
import greifOrderUploadReducer, {
    GreifComponentsOrderUploadActions,
} from "@store/Framework/Store/Greif/Components/GreifOrderUpload/GreifOrderUploadReducer";
import InviteYourColleagueFormReducer, {
    GreifComponentsInviteYourColleagueFormActions,
} from "@store/Framework/Store/Greif/Components/InviteYourColleague/InviteYourColleagueFormReducer";
import RecommendedProductRequestFormReducer, {
    GreifComponentsRecommendedProductRequestFormActions,
} from "@store/Framework/Store/Greif/Components/RecommendedProductRequest/RecommendedProductRequestFormReducer";
import { combineReducers } from "redux";

const componentsReducers = {
    greifOrderUpload: greifOrderUploadReducer,
    cookiePrivacyPolicy: cookiePrivacyPolicyReducer,
    inviteYourColleagueForm: InviteYourColleagueFormReducer,
    recommendedProductRequestForm: RecommendedProductRequestFormReducer,
    changeCustomerModal: ChangeCustomerModalReducer,
};

export type GreifComponentsActions =
    | GreifComponentsOrderUploadActions
    | GreifComponentsCookiePrivacyPolicyActions
    | GreifComponentsInviteYourColleagueFormActions
    | GreifComponentsRecommendedProductRequestFormActions
    | GreifComponentsChangeCustomerModalActions;

export default combineReducers(componentsReducers);
